import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-alabaster pt-24 pb-12 px-6" data-id="element-20">
      <div className="max-w-7xl mx-auto" data-id="element-21">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-16 mb-24" data-id="element-22">
          <div className="col-span-2 lg:col-span-1 space-y-8" data-id="element-23">
            <div className="flex items-center gap-2" data-id="element-24">
              <div className="bg-white p-3 rounded-xl inline-block" data-id="element-25">
                <img src="https://cdn.magicpatterns.com/uploads/28ZTKaKZzKVJqAkn3TE3hV/ChatGPT_Image_May_21,_2026,_07_24_32_PM.png" alt="NK Refacers Logo" className="h-20 w-auto object-contain" data-id="element-26" />
              </div>
            </div>
            <p className="text-alabaster/40 leading-relaxed" data-id="element-27">
              Bowie's premier destination for luxury kitchen cabinet refacing.
              We combine traditional craftsmanship with modern technology.
            </p>
            <div className="flex gap-4" data-id="element-28">
              <a href="#" className="w-10 h-10 border border-alabaster/20 flex items-center justify-center hover:bg-espresso transition-colors" data-id="element-29">
                <FacebookIcon className="w-5 h-5" data-id="element-30" />
              </a>
              <a href="#" className="w-10 h-10 border border-alabaster/20 flex items-center justify-center hover:bg-espresso transition-colors" data-id="element-31">
                <InstagramIcon className="w-5 h-5" data-id="element-32" />
              </a>
              <a href="#" className="w-10 h-10 border border-alabaster/20 flex items-center justify-center hover:bg-espresso transition-colors" data-id="element-33">
                <TwitterIcon className="w-5 h-5" data-id="element-34" />
              </a>
            </div>
          </div>

          <div data-id="element-35">
            <h4 className="font-bold uppercase tracking-widest text-sm mb-8" data-id="element-36">
              Navigation
            </h4>
            <ul className="space-y-4 text-alabaster/60 font-medium" data-id="element-37">
              <li data-id="element-38">
                <a href="/process" className="hover:text-espresso transition-colors" data-id="element-39">
                  Our Process
                </a>
              </li>
              <li data-id="element-40">
                <a href="/showroom" className="hover:text-espresso transition-colors" data-id="element-41">
                  Door Styles
                </a>
              </li>
              <li data-id="element-42">
                <a href="/pricing" className="hover:text-espresso transition-colors" data-id="element-43">
                  Pricing
                </a>
              </li>
              <li data-id="element-44">
                <a href="/faq" className="hover:text-espresso transition-colors" data-id="element-45">
                  FAQ
                </a>
              </li>
              <li data-id="element-46">
                <a href="/get-quote" className="hover:text-espresso transition-colors" data-id="element-47">
                  Get a Quote
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-48">
            <h4 className="font-bold uppercase tracking-widest text-sm mb-8" data-id="element-49">
              Contact Bowie
            </h4>
            <ul className="space-y-6 text-alabaster/60" data-id="element-50">
              <li className="flex gap-4" data-id="element-51">
                <MapPinIcon className="w-5 h-5 text-espresso shrink-0" data-id="element-52" />
                <span data-id="element-53">
                  1234 Craftsmanship Way,
                  <br data-id="element-54" />
                  Bowie, MD 20715
                </span>
              </li>
              <li className="flex gap-4" data-id="element-55">
                <PhoneIcon className="w-5 h-5 text-espresso shrink-0" data-id="element-56" />
                <span data-id="element-57">(301) 555-0123</span>
              </li>
              <li className="flex gap-4" data-id="element-58">
                <MailIcon className="w-5 h-5 text-espresso shrink-0" data-id="element-59" />
                <span className="break-words overflow-hidden" data-id="element-60">
                  hello@nkrefacers.com
                </span>
              </li>
            </ul>
          </div>

          <div data-id="element-61">
            <h4 className="font-bold uppercase tracking-widest text-sm mb-8" data-id="element-62">
              Newsletter
            </h4>
            <p className="text-sm text-alabaster/40 mb-6" data-id="element-63">
              Get kitchen design tips and exclusive offers.
            </p>
            <div className="flex border-b-2 border-alabaster/20 pb-2" data-id="element-64">
              <input type="email" placeholder="Email Address" className="bg-transparent outline-none flex-grow text-sm" data-id="element-65" />
              <button className="text-espresso font-bold text-sm uppercase tracking-widest" data-id="element-66">
                Join
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-alabaster/10 pt-12 flex flex-col md:flex-row justify-between items-center gap-6 text-xs font-bold uppercase tracking-[0.2em] text-alabaster/20" data-id="element-67">
          <p data-id="element-68">© 2026 NK Refacers. All Rights Reserved.</p>
          <div className="flex gap-8" data-id="element-69">
            <a href="/privacy" className="hover:text-alabaster transition-colors" data-id="element-70">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-alabaster transition-colors" data-id="element-71">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}